import { EntityBase } from './EntityBase';
import { Reference } from './Reference';
import { Author } from './Author';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class ReferenceAuthor extends EntityBase {

   /// <code> Place custom code between <code> tags
   public get authorInitials() {
      return this.author.initials;
   }

   public get authorName() {
      return this.author.authorName;
   }

   public get referenceYearOfPublication() {
      return this.reference.yearOfPublication;
   }

   public get referenceTitle() {
      return this.reference.title;
   }

   /// </code>

   // Generated code. Do not place code below this line.
   referenceId: number;
   authorId: number;
   counter: number;
   created: Date;
   createdUser: string;
   modified: Date;
   modifyUser: string;
   rowVersion: number;
   author: Author;
   reference: Reference;
}

